import React, { FC } from 'react';

import Svg from './Svg';
import colors from '../../utils/colorConstants';

interface Props {
  className?: string;
  stroke?: string;
  height?: string;
  width?: string;
}

const Blocks: FC<Props> = ({
  className,
  stroke = colors.lapel,
  height = '1.5rem',
  width = '1.5rem',
}) => (
  <Svg className={className} height={height} title="blocks" viewBox="0 0 24 24" width={width}>
    <g fillRule="evenodd">
      <g transform="translate(3 3)">
        <path
          d="M17.44 15.38A3.53 3.53 0 0114.5 17a3.49 3.49 0 01-3.5-3.5 3.5 3.5 0 017 0c0 .7-.2 1.34-.56 1.88zM10 15H2a1 1 0 01-1-1V2a1 1 0 011-1h14a1 1 0 011 1v7.76A4.5 4.5 0 0010.28 15H10zm8-4.3V2a2 2 0 00-2-2H2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h8.76A4.5 4.5 0 1018 10.7z"
          fill={stroke}
        />
      </g>
      <path
        d="M19 16h-1v-1a.5.5 0 00-1 0v1h-1a.5.5 0 000 1h1v1a.5.5 0 001 0v-1h1a.5.5 0 000-1"
        fill={stroke}
      />
    </g>
  </Svg>
);

export default Blocks;
